import { Controller as BaseController } from 'stimulus'

export default class extends BaseController {
  static targets = ['form', 'submitButton']

  static values = {
    validateForm: Boolean,
    validationStrategy: String,
    validationStrategyOptions: Object
  }

  connect() {
    if (this.validateFormValue) this.setupObserver()
  }

  setupObserver() {
    const observer = new MutationObserver(() => this.toggleSubmitButton())

    if (this.hasFormTarget) {
      observer.observe(this.formTarget, { childList: true, subtree: true })
    }
  }

  toggleSubmitButton() {
    if (this.hasSubmitButtonTarget) this.submitButtonTarget.disabled = !this.isFormValid()
  }

  isFormValid() {
    switch (this.validationStrategyValue) {
      case 'multipleElementsPresent':
        return this.checkMultipleElementsPresent()
      default:
        break
    }
  }

  checkMultipleElementsPresent() {
    const options = this.validationStrategyOptionsValue

    return this.formTarget.querySelectorAll(options.identifier).length > options.threshold
  }
}
